import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MissedFieldsReports = () => {
  const [reports, setReports] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/missed-fields`, { withCredentials: true }).then(({ data }) => setReports(data.reports)).catch(() => {});
  }, []);

  return (
    <section className="border border-border mt-6" data-testid="admin-missed-fields">
      <div className="px-5 py-3 border-b border-border bg-secondary/30 flex items-center justify-between">
        <h2 className="font-heading text-sm uppercase tracking-widest">MISSED FIELD REPORTS</h2>
        <span className="text-[10px] uppercase tracking-widest text-muted-foreground">{reports.length} reports</span>
      </div>
      {reports.length === 0 ? (
        <div className="p-8 text-center text-xs uppercase tracking-widest text-muted-foreground">No reports yet</div>
      ) : (
        reports.map((r) => (
          <div key={r.report_id} className="border-b border-border/60" data-testid={`missed-report-${r.report_id}`}>
            <button onClick={() => setOpen(open === r.report_id ? null : r.report_id)} className="w-full text-left px-5 py-3 flex items-center justify-between gap-3 hover:bg-secondary/20">
              <span className="font-mono text-xs truncate">{r.domain} · {r.fields.length} fields · {r.email}</span>
              <span className="text-[10px] uppercase tracking-widest text-muted-foreground shrink-0">{new Date(r.created_at).toLocaleDateString()}</span>
            </button>
            {open === r.report_id && (
              <div className="px-5 pb-4 overflow-x-auto">
                <a href={r.url} target="_blank" rel="noopener noreferrer" className="text-xs text-primary break-all">{r.url}</a>
                <table className="w-full text-[11px] mt-2 font-mono">
                  <thead><tr className="text-left text-muted-foreground"><th className="pr-3">TYPE</th><th className="pr-3">NAME</th><th className="pr-3">ID</th><th className="pr-3">LABEL</th><th>PLACEHOLDER</th></tr></thead>
                  <tbody>
                    {r.fields.map((f, i) => (
                      <tr key={i} className="border-t border-border/40">
                        <td className="pr-3 py-1">{f.tag?.toLowerCase()}/{f.type}</td>
                        <td className="pr-3">{f.name}</td>
                        <td className="pr-3">{f.id}</td>
                        <td className="pr-3">{f.label || f.aria}</td>
                        <td>{f.ph}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))
      )}
    </section>
  );
};
